import {useIntl} from "react-intl";
import classNames from "classnames/bind";
import closeIcon from "images/ic_close.svg";
import DropDownIcon from "assets/image/Layout/PropertyPanel/ic_dropdown_fold.svg";
import styles from "./index.module.scss";
import {
  MODE_TYPE,
  SSAFY9_CODE,
  SSAFY9_ORGANIZATION,
  SSAFY10_CODE,
  SSAFY10_ORGANIZATION,
  SSAFY11_CODE,
  SSAFY11_ORGANIZATION,
  SEN_CODE,
  SEN_ORGANIZATIONS,
  ICE_CODE,
  IEN_ORGANIZATIONS,
  CLASS_CODE_LIST,
  enumCompetitonType,
} from "utils";
import SelectDropDown from "components/Common/Dropdown/SelectDropDown";
import {useState} from "react";
// import {MODE} from "components/OOBCEditor/Component/Selector";

const cn = classNames.bind(styles);

function View({
  publishForm,
  progress,
  isClickUpload,
  dismiss,
  submitUpload,
  thumbPreview,
  isShowJoinToggle,
  onClickJoinToggle,
  selectedOrganization,
  onClickOrganization,
  onClickPublishMode,
  group,
  searchData,
  setSearchData,
  onClickContests,
  contest,
}) {
  const {
    register,
    handleSubmit,
    watch,
    formState: {errors},
  } = publishForm;

  const ORAGANIZATIONS = {
    [SSAFY9_CODE]: SSAFY9_ORGANIZATION,
    [SSAFY10_CODE]: SSAFY10_ORGANIZATION,
    [SSAFY11_CODE]: SSAFY11_ORGANIZATION,
    [SEN_CODE]: SEN_ORGANIZATIONS,
    [ICE_CODE]: IEN_ORGANIZATIONS,
  };

  const HAS_TEAM_CLASS_CODE = [...CLASS_CODE_LIST, SSAFY9_CODE, SSAFY10_CODE, SSAFY11_CODE];
  const organization = group && ORAGANIZATIONS[group] ? ORAGANIZATIONS[group] : [];
  const name = watch("name");
  const description = watch("description");
  const intl = useIntl();

  const [currentMode, setCurrentMode] = useState(MODE_TYPE.SINGLEPLAY_MODE);
  const [isDropDownOpen, setIsDropDownOpen] = useState(false);
  const handleModeChange = mode => {
    onClickPublishMode(mode);
    setCurrentMode(mode);
    setIsDropDownOpen(false);
  };
  const handleDropDown = () => {
    setIsDropDownOpen(prev => !prev);
  };

  const [isContestDropDownOpen, setIsContestDropDownOpen] = useState(false);
  const handleContestDropDown = () => {
    setIsContestDropDownOpen(prev => !prev);
  };
  const handleContestChange = e => {
    onClickContests(e);
    setIsContestDropDownOpen();
  };

  const [isOrganizationDropDownOpen, setIsOrganizationDropDownOpen] = useState(false);
  const handleOrganizationDropDown = () => {
    setIsOrganizationDropDownOpen(prev => !prev);
  };
  const handleOrganizationChange = title => {
    onClickOrganization(title);
    setIsOrganizationDropDownOpen();
  };

  return (
    <form className={cn("popup")} onSubmit={handleSubmit(submitUpload)}>
      <header>
        Publish Place
        <img onClick={dismiss} src={closeIcon} alt="close popup" />
      </header>
      {!isClickUpload ? (
        <div className={cn("content")}>
          <div className={cn("line")}>
            <div className={cn("titleline")}>
              <p className={cn("title", "redstar")}>Name</p>
              <span>{name?.length}/50</span>{" "}
            </div>
            <div className={cn("wrap")}>
              <input
                type="text"
                maxLength={50}
                autoComplete="off"
                className={cn("name", errors?.name && "error")}
                {...register("name")}
                placeholder={intl.formatMessage({
                  id: "ID_PUBLISH_POPUP_TITLE_PLACEHOLDER",
                })}
              />
            </div>
          </div>
          <div className={cn("line")}>
            <div className={cn("titleline")}>
              <p className={cn("title", "redstar")}>Description</p> <span>{description?.length}/1000</span>
            </div>
            <div className={cn("wrap")}>
              <textarea
                id=""
                maxLength={1000}
                autoComplete="off"
                className={cn(errors?.description && "error")}
                {...register("description")}
                placeholder={intl.formatMessage({
                  id: "ID_PUBLISH_POPUP_DESCRIPTION_PLACEHOLDER",
                })}
              />
            </div>
          </div>

          {/* TODO 싱글 또는 멀티모드로 플레이 모드를 설정합니다. */}

          <div className={cn("line")}>
            <p className={cn("title")}>Thumbnail</p>
            <div className={cn("filebox")}>
              <label htmlFor="thumbnail" className={cn("thumbnail_label")}>
                {thumbPreview && <img src={thumbPreview} alt="thumbnail" />}
              </label>
              {errors?.thumbnail && <p className={cn("thumb_error")}>{errors.thumbnail.message}</p>}
              <input
                type="file"
                id="thumbnail"
                accept=".jpg,.jpeg,.png"
                {...register("thumbnail", {
                  validate: {
                    lessThan3MB: files => files[0]?.size < 3 * 3 * 1000 * 1000 || "최대 3MB",
                  },
                })}
              />
            </div>
          </div>

          <div className={cn("line", "line_team")}>
            <p className={cn("title")}>Playmode</p>
            <div className={cn("wrap")}>
              <div className={cn("playmode")}>
                <div onClick={currentMode && handleDropDown}>
                  {currentMode === MODE_TYPE.SINGLEPLAY_MODE ? (
                    <div>
                      <p className={cn("mode_text")}>Single</p>
                      <img className={cn("rotate")} alt="dropdown icon" src={DropDownIcon} />
                    </div>
                  ) : (
                    <div>
                      <p className={cn("mode_text")}>Multi</p>
                      <img className={cn("rotate")} alt="dropdown icon" src={DropDownIcon} />
                    </div>
                  )}
                </div>
                {isDropDownOpen && (
                  <SelectDropDown style={{width: "304px", top: "-80px"}}>
                    <div className={cn("mode_text")} onClick={() => handleModeChange(MODE_TYPE.MULTIPLAY_MODE)}>
                      Multi
                    </div>
                    <div className={cn("mode_text")} onClick={() => handleModeChange(MODE_TYPE.SINGLEPLAY_MODE)}>
                      Single
                    </div>
                  </SelectDropDown>
                )}
              </div>
            </div>
          </div>
          <PublishDropDown
            name={"Challenge/Contest"}
            value={contest}
            titles={Object.keys(enumCompetitonType)}
            func={handleContestChange}
            handleDropDown={handleContestDropDown}
            isDropDownOpen={isContestDropDownOpen}
          />
          {group && HAS_TEAM_CLASS_CODE.includes(group) && (
            <PublishDropDown
              name={"Team"}
              value={isShowJoinToggle ? searchData : selectedOrganization}
              titles={organization.filter(data => (searchData ? data.includes(searchData) : data))}
              func={handleOrganizationChange}
              handleDropDown={handleOrganizationDropDown}
              isDropDownOpen={isOrganizationDropDownOpen}
            />
          )}
          <div className={cn("buttons")}>
            <button type="button" onClick={dismiss} className={cn("button")}>
              Cancel
            </button>
            <button className={cn("button", "upload")}>Publish</button>
          </div>
        </div>
      ) : progress < 100 ? (
        <div className={cn("uploading")}>
          <div className={cn("uploading_box")}>
            <p>Uploading 3D world..</p>
            <div className={cn("progress_box")}>
              <p className={cn("progress_value")}>{progress}%</p>
              <div className={cn("uploading_progress")}>
                <div style={{width: `${progress}%`}} />
              </div>
            </div>
          </div>
          <button type="button" className={cn("button")} onClick={dismiss}>
            Cancel
          </button>
        </div>
      ) : (
        <div className={cn("uploading")}>
          <div className={cn("uploading_box")}>
            <p>Publishing completed.</p>
            <div className={cn("progress_box", "comleted")}></div>
          </div>
          <button type="button" className={cn("button")} onClick={dismiss}>
            Confirm
          </button>
        </div>
      )}
    </form>
  );
}

export default View;

const PublishDropDown = ({name, value, titles, func, close, handleDropDown, isDropDownOpen}) => {
  // 이렇게 한다음에 타이틀을 SelectDropDown에 map돌리자
  // name이 항목 이름
  // value가 선택된 값(드랍다운 인풋에 표시될 값)

  return (
    <div className={cn("line", "line_team")}>
      <p className={cn("title")}>{name}</p>
      <div className={cn("wrap")}>
        <div className={cn("playmode")}>
          <div onClick={handleDropDown}>
            <div>
              <p className={cn("mode_text")}>{value}</p>
              <img className={cn("rotate")} alt="dropdown icon" src={DropDownIcon} />
            </div>
          </div>
          {isDropDownOpen && (
            <SelectDropDown style={{width: "304px", top: "-80px"}}>
              {titles.map(title => (
                <div className={cn("drop_input")} title={title} onClick={() => func(title)} key={title}>
                  {title}
                </div>
              ))}
            </SelectDropDown>
          )}
        </div>
      </div>
    </div>
  );
};
